export module UrlUtility {
  export const concatUrlAndQueryParams = (
    url: string,
    params: Record<string, unknown>,
  ): string => {
    const queryString = Object.entries(params).map(([key, value]) => {
      return `${key}=${value}`
    }).join('&')

    return `${url}?${queryString}`
  }

  export const buildUrl = (
    item: { url: string, urlReplaceStyle: string }
  ): string => {
    if (item.urlReplaceStyle === 'cms') {
      const CMS_BASE_URL = process.env.REACT_APP_CMS_DOMAIN ?? ''
      const result = new URL(item.url, CMS_BASE_URL)
      return result.toString()
    }
    return item.url
  }
}
